export const GROUP_SETTINGS = {
	ZEZAMII_LOCKER: 23,
	ACCESS: 24,
	GENERAL: 25,
	CONTROL: 26,
	INNER_RANGE: 27,
	AVIGILON_ALTA: 32
};
